module.exports = __webpack_public_path__ + "static/img/friction.fd79a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/friction.png
// module id = feQG
// module chunks = 1